import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './sass/base/main.scss';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from './themes/ThemeProvider';
// import ThemeSwitcher from './themes/ThemeSwitcher';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import WidgetSwitcher from "./themes/WidgetSwitcher";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      {/* <ThemeSwitcher /> */}
      {/* <WidgetSwitcher /> */}
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
